import React, { Fragment } from 'react'
import styles from './FormStepper.scss'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import tinycolor from 'tinycolor2'
import { darken } from 'polished'
import { classNames } from './../../utils/styles'
import { getPrefixPath, getCurrentPath } from './../../services/routeService'

const StyledLine = styled.div`
  ${({ isPassed, theme }) => `
    background: ${theme.colors.sky.base};
    ${isPassed && `background: ${theme.primaryColor};`}
  `};
`

const StyledIndicator = styled.div`
  ${({ isPassed, theme }) => `
    background: ${theme.colors.ink.lightest};
    ${isPassed && `background: ${theme.primaryColor};`}
  `};
`
const StyledName = styled.div`
  ${({ isPassed, theme }) => `
    color: ${theme.colors.sky.base};
    ${isPassed &&
      `color: ${
        tinycolor(theme.primaryColor).getLuminance() > 0.5 ? darken(0.25, theme.primaryColor) : theme.primaryColor
      };`}
  `};
`

export default function FormStepper({ steps }) {
  const currentPath = getCurrentPath()
  const currentStep = steps.findIndex(step => step.to === currentPath)

  return (
    <div className={styles.FormStepper}>
      {steps.map((item, key) => {
        if (!item.visible) {
          return null
        }
        const isPassed = currentStep >= key

        return (
          <Fragment key={key}>
            {key > 0 && <StyledLine className={styles.Line} isPassed={isPassed} />}
            {currentStep > key ? (
              <Link to={getPrefixPath() + item.to} className={classNames(styles.Step, styles.Past)}>
                <StyledIndicator className={styles.Indicator} isPassed={isPassed} />
                <StyledName className={styles.Name} isPassed={isPassed}>
                  {item.content}
                </StyledName>
              </Link>
            ) : (
              <div className={classNames(styles.Step, currentStep === key && styles.Active)}>
                <StyledIndicator className={styles.Indicator} isPassed={isPassed} />
                <StyledName className={styles.Name} isPassed={isPassed}>
                  {item.content}
                </StyledName>
              </div>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

FormStepper.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/FormStepper/index.js